// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._6hAM0Zztx{display:block;height:0;width:0}", "",{"version":3,"sources":["webpack://./client/shared/tabtrap/tabtrap.scss"],"names":[],"mappings":"AAAA,YACE,aAAA,CACA,QAAA,CACA,OAAA","sourcesContent":[".sentinel {\n  display: block;\n  height: 0;\n  width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sentinel": "_6hAM0Zztx"
};
export default ___CSS_LOADER_EXPORT___;
